(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dattelmond-delivery-trust"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-trust')) {
    customElements.define(
      'delivery-trust',
      class DeliveryTrust extends HTMLElement {
        connectedCallback() {
          this.renderDates();
        }

        getZurichNow() {
          const parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: this.dataset.timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            hourCycle: 'h23'
          }).formatToParts(new Date());
          const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
          return {
            date: new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day))),
            hour: Number(values.hour)
          };
        }

        excludedDates() {
          return new Set(
            (this.dataset.excludedDates || '')
              .split(',')
              .map((value) => value.trim())
              .filter(Boolean)
          );
        }

        isoDate(date) {
          return date.toISOString().slice(0, 10);
        }

        isBusinessDay(date, excluded) {
          const day = date.getUTCDay();
          return day !== 0 && day !== 6 && !excluded.has(this.isoDate(date));
        }

        addBusinessDays(start, amount, excluded) {
          const date = new Date(start.getTime());
          let added = 0;
          while (added < amount) {
            date.setUTCDate(date.getUTCDate() + 1);
            if (this.isBusinessDay(date, excluded)) added += 1;
          }
          return date;
        }

        formatDate(date) {
          return new Intl.DateTimeFormat(this.dataset.locale, {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
            timeZone: 'UTC'
          }).format(date);
        }

        formatCompactDate(date) {
          return new Intl.DateTimeFormat(this.dataset.locale, {
            weekday: 'short',
            day: 'numeric',
            timeZone: 'UTC'
          }).format(date);
        }

        renderDates() {
          const orderNode = this.querySelector('[data-delivery-order-date]');
          const dispatchNode = this.querySelector('[data-delivery-dispatch-date]');
          const arrivalNode = this.querySelector('[data-delivery-arrival-date]');
          const mobileOrderNode = this.querySelector('[data-delivery-mobile-order-date]');
          const mobileDispatchNode = this.querySelector('[data-delivery-mobile-dispatch-date]');
          const mobileArrivalNode = this.querySelector('[data-delivery-mobile-arrival-date]');
          if (!orderNode || !dispatchNode || !arrivalNode || !mobileOrderNode || !mobileDispatchNode || !mobileArrivalNode) return;

          const now = this.getZurichNow();
          const excluded = this.excludedDates();
          const cutoff = Number(this.dataset.cutoffHour || 20);
          const orderDay = now.date.getUTCDay();
          const isWeekend = orderDay === 0 || orderDay === 6;
          const dispatchSteps = !isWeekend && now.hour >= cutoff ? 2 : 1;
          const dispatchDate = this.addBusinessDays(now.date, dispatchSteps, excluded);
          const arrivalStart = this.addBusinessDays(dispatchDate, 2, excluded);

          orderNode.dateTime = this.isoDate(now.date);
          orderNode.textContent = `${this.dataset.todayLabel}, ${this.formatDate(now.date)}`;
          dispatchNode.dateTime = this.isoDate(dispatchDate);
          dispatchNode.textContent = this.formatDate(dispatchDate);
          arrivalNode.textContent = this.formatDate(arrivalStart);
          mobileOrderNode.dateTime = this.isoDate(now.date);
          mobileOrderNode.textContent = this.dataset.todayLabel;
          mobileDispatchNode.dateTime = this.isoDate(dispatchDate);
          mobileDispatchNode.textContent = this.formatCompactDate(dispatchDate);
          mobileArrivalNode.dateTime = this.isoDate(arrivalStart);
          mobileArrivalNode.textContent = this.formatCompactDate(arrivalStart);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
